interface Props {
	value: string
}

const CustomerChip: React.FC<Props> = ({ value }) => {
	let className = ''

	if (value.toLowerCase() === 'enterprise') {
		className = 'badge-kumopack-primary-100 text-kumopack-primary-600'
	} else if (value.toLowerCase() === 'business') {
		className = 'badge-kumopack-secondary-100 text-kumopack-secondary-600'
	} else {
		className = 'badge-kumopack-secondary-100 text-kumopack-primary-600'
	}

	return (
		<div className={`badge ${className} border-radius-16px`}>
			{value.toLowerCase() === 'business' && (
				<img src="/media/icons/kumopack/blue-arrow-up.svg" alt="Enterprise / Business Customer" />
			)}

			{value}
		</div>
	)
}

export default CustomerChip
